// Global Vars
const filtersContainer = $('.filters-data-container');
const filtersData = $(filtersContainer).find('.filter-data-list-item');
const urlSearchParams = new URLSearchParams(window.location.search);
const coursesListLimit = $('.courses-list').data('limit');

// Preset url filtering
document.addEventListener('preloaded', function () {
    const dropdownFilters = $('.filter-dropdown');

    if (dropdownFilters) {
        dropdownFilters.each((i, el) => {
            const filter = el.dataset.filter;
            const filterValue = el.dataset.filterslug;
            const urlFilterValue = urlSearchParams.get('filter-' + filter);
            const isUrlMatchingFilterByValue = urlFilterValue && urlFilterValue === filterValue;

            if (isUrlMatchingFilterByValue) {
                el.classList.add('active');

                const dropdownTitle = $(el).parents('.filters__filter').find('.dropdown-title');

                dropdownTitle.text($(el).text());
                dropdownTitle.show();

                const dropdownDefaultTitle = $(el).parents('.filters__filter').find('.dropdown-default-title');

                dropdownDefaultTitle.hide();
            }
        });

        const urlFilterQuery = filterMultiple();

        if (urlFilterQuery) {
            const filtersDataVisible = $(filtersContainer).find('.filter-data-list-item' + urlFilterQuery);

            showFilteredData(filtersDataVisible, null);

            addDisplayClassToLimitedCourseList(filtersDataVisible);

            filtersContainer.parents('.section')[0].scrollIntoView();
        }
    }
}, false);

// Filter
$('.filter-dropdown').on('click', function (event) {

    // Disable Link
    event.preventDefault();
    event.stopPropagation();

    const dropdownMenu = $(this).parents('.dropdown-menu');

    const currentDropdownActiveFilters = dropdownMenu.find('.filter-dropdown.active');
    resetAllActiveFilters(currentDropdownActiveFilters);

    // Add active to current filter
    $(this).addClass('active');

    // Update dropdown title to current filter
    const dropdownTitle = $(dropdownMenu).parents('.filters__filter').find('.dropdown-title');
    dropdownTitle.text($(this).text());
    dropdownTitle.show();

    const dropdownDefaultTitle = $(dropdownMenu).parents('.filters__filter').find('.dropdown-default-title');
    dropdownDefaultTitle.hide();

    // Reset limited display of list
    filtersData.removeClass(['d-block', 'show-limited', 'hide', 'd-none']);

    // Multiple filter by query
    const filterQuery = filterMultiple();
    const filtersDataVisible = $(filtersContainer).find('.filter-data-list-item' + filterQuery);

    showFilteredData(filtersDataVisible, dropdownMenu);

    addDisplayClassToLimitedCourseList(filtersDataVisible);
});

// Reset all filters
$('.courses-list-filters-reset').on('click', function (event) {
    // Disable Link
    event.preventDefault();
    event.stopPropagation();

    // Reset active filters
    const activeDropdownFilters = $('.filter-dropdown.active');

    resetAllActiveFilters(activeDropdownFilters);

    // Reset limited display of list
    filtersData.removeClass(['d-block', 'show-limited', 'hide', 'd-none']);

    // Show full list
    const filtersDataVisible = filtersData;

    showFilteredData(filtersDataVisible, null);

    addDisplayClassToLimitedCourseList(filtersDataVisible);

    // Reset url filter query
    urlSearchParams.delete('title');
    window.history.replaceState(null, null, window.location.pathname);

    // Hide filters btn
    $('.courses-list-filters-reset').addClass('d-none');
});

// Reset all active filters
function resetAllActiveFilters(activeFilters) {
    activeFilters.each((i, el) => {
        el.classList.remove('active');

        const dropdownTitle = $(el).parents('.filters__filter').find('.dropdown-title');
        dropdownTitle.hide();

        const dropdownDefaultTitle = $(el).parents('.filters__filter').find('.dropdown-default-title');
        dropdownDefaultTitle.show();

        // Reset parameters
        urlSearchParams.delete('filter-' + el.dataset.filter);
    });
}

// Multiple Filter and display of active filters
function filterMultiple() {
    let filterQuery = '';

    const currentActiveFilter = $('.filter-dropdown.active');

    currentActiveFilter.each((i, el) => {
        const filter = el.dataset.filter;
        const filterValue = el.dataset.filterslug;
        const urlFilterName = 'filter-' + filter

        filterQuery += '[data-' + filter + '*="' + filterValue + '"]'

        urlSearchParams.set(urlFilterName, filterValue);
    });

    // Push filter query to url
    const hasUrlParameters = Array.from(urlSearchParams).length > 0;
    const urlWithParameters = window.location.pathname + (hasUrlParameters ? ('?' + urlSearchParams) : '');

    window.history.replaceState(null, null, urlWithParameters);

    // Display or hide filters btn if has url parameters
    if (hasUrlParameters) {
        $('.courses-list-filters-reset').removeClass('d-none');
    } else {
        $('.courses-list-filters-reset').addClass('d-none');
    }

    return filterQuery;
}

function showFilteredData(filtersDataVisible, dropdownMenu) {
    // Fill up Filters Count
    $('.filters-count').text(filtersDataVisible.length);

    if (filtersDataVisible.length == 0) {
        $('.no-courses').removeClass('d-none');
    } else {
        $('.no-courses').addClass('d-none');
    }

    // Load all Cards before filtering
    $(filtersContainer).find('.filter-data-list-item:hidden').show();

    // Hide Dropdown
    if (dropdownMenu) {
        $(dropdownMenu).dropdown('hide');
        $(dropdownMenu).siblings('.filter-btn').attr('aria-expanded', false);
    }

    // Hide all Cards
    $(filtersData).hide();

    // Show Cards by Filter
    $(filtersDataVisible).show();
}

function addDisplayClassToLimitedCourseList(filtersDataVisible) {
    // Create limited display of items in courses list
    if (coursesListLimit > 0) {
        filtersDataVisible.each((i, el) => {
            if ((i + 1) <= coursesListLimit) {
                $(el).addClass(['d-block', 'show-limited']);
            } else {
                $(el).addClass(['d-none', 'hide']);
            }
        });

        // Toggle more load btn
        if (filtersDataVisible.length <= coursesListLimit) {
            $('.courses-list-load-more').hide();
        } else {
            $('.courses-list-load-more').show();
        }
    }
}
